import React from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { Button } from 'ayvri-ui/lib/button';
import PlayerState from '../../PlayerState';
import style from './playerHeader.css';
import { buildAssetUrl } from '../../helpers';
const logoColor = 'assets/images/logos/ayvri-logo-color.svg';
const Logo = ({ playerStarted }) => (React.createElement("a", { href: 'http://ayvri.com', className: `${style.logo} hideOnWebsite` },
    React.createElement("img", { className: !playerStarted ? style.colorLogo : null, src: buildAssetUrl(logoColor), alt: 'Ayvri logo' })));
const CreditsContainer = () => (React.createElement("div", { className: style.credits },
    React.createElement("span", { className: 'creditContainer' })));
const IntegrationLogo = ({ integrations }) => {
    // For now, only display a single integration, even though there may be multiple
    const integration = integrations.find(i => i.appIconUrl);
    if (!integration)
        return null;
    return (React.createElement("a", { href: integration.companyUrl, className: `${style.logo} ${style.integration}` },
        React.createElement("img", { src: integration.appIconUrl, alt: `${integration.name} logo` })));
};
const DevModeDisclaimer = () => React.createElement("div", { className: style.devMode }, "Dev Mode");
const Header = ({ isDevMode, playerStarted, integrations, showCreateMore }) => (React.createElement("div", null,
    React.createElement("div", { className: style.logoHolder },
        React.createElement(Logo, { playerStarted: playerStarted }),
        React.createElement(IntegrationLogo, { integrations: integrations }),
        React.createElement(CreditsContainer, null),
        isDevMode ? React.createElement(DevModeDisclaimer, null) : '',
        showCreateMore ? (React.createElement("div", { className: style.promoButton },
            React.createElement(Button, { size: 'small', type: 'outline', onClick: () => {
                    window.open('/', '_new');
                } }, "Create Your Own"))) : null)));
const accountTypeSelector = state => state.scene.accountType;
const isEmbedSelector = state => state.layout.isEmbed;
const isMobileSelector = state => state.layout.isMobile;
const showCreateMoreSelector = createSelector(accountTypeSelector, isEmbedSelector, isMobileSelector, (accountType, isEmbed, isMobile) => {
    // Show the "Create Your Own" button if this is an embedded, non-API created scene viewed on desktop
    const isUserAccount = accountType !== 'api';
    return isEmbed && isUserAccount && !isMobile;
});
const mapStateToProps = state => ({
    isDevMode: state.scene.devMode,
    showCreateMore: showCreateMoreSelector(state),
    playerStarted: state.loading.playerState >= PlayerState.LOADING,
    integrations: state.scene.integrations,
});
export default connect(mapStateToProps)(Header);
